import { useState } from "react";
import { Reveal, SectionHead } from "@/components/Reveal";

const EVENT_IDEAS = [
  {
    title: "Product Launch",
    tag: "High Impact Brand Activation",
    url: "https://images.unsplash.com/photo-1774599661395-569eea1420e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwYnVpbGRpbmclMjBvdXRkb29yJTIwZXZlbnR8ZW58MHx8fHwxNzkxNDI5ODY3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Shopping Centre Takeover",
    tag: "Footfall Booster",
    url: "https://images.unsplash.com/photo-1539657523674-fbd149b04c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxvdXRkb29yJTIwc3BvcnRzJTIwZXZlbnQlMjBjcm93ZHxlbnwwfHx8fDE3OTE0Mjk4Njd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Market & Festival",
    tag: "Community Crowd Attraction",
    url: "https://images.unsplash.com/photo-1537228783107-df09e892bdbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxvdXRkb29yJTIwc3BvcnRzJTIwZXZlbnQlMjBjcm93ZHxlbnwwfHx8fDE3OTE0Mjk4Njd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Music & Cultural Event",
    tag: "VIP Fan Zone",
    url: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxtdXNpYyUyMGZlc3RpdmFsJTIwbmlnaHQlMjBjcm93ZHxlbnwwfHx8fDE3OTE0MzA4NDl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Social & Private Party",
    tag: "Milestone Celebrations",
    url: "https://images.unsplash.com/photo-1774599661153-0bc597adc8f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwYnVpbGRpbmclMjBvdXRkb29yJTIwZXZlbnR8ZW58MHx8fHwxNzkxNDI5ODY3fDA&ixlib=rb-4.1.0&q=85",
  },
];

const ACTIVATIONS = [
  {
    label: "Fed Square Takeover",
    stat: "3 courts · 120 players",
    url: "https://images.unsplash.com/photo-1756477558468-b3e485757470?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxwaWNrbGViYWxsJTIwY291cnQlMjBhY3Rpb258ZW58MHx8fHwxNzkxNDI5ODY3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "Southbank Corporate Day",
    stat: "2 courts · 6 day residency",
    url: "https://images.unsplash.com/photo-1774599661395-569eea1420e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwYnVpbGRpbmclMjBvdXRkb29yJTIwZXZlbnR8ZW58MHx8fHwxNzkxNDI5ODY3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "Moomba Festival Courts",
    stat: "4 courts · 900+ rallies",
    url: "https://images.unsplash.com/photo-1737476997205-b3336182f215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwaWNrbGViYWxsJTIwY291cnQlMjBhY3Rpb258ZW58MHx8fHwxNzkxNDI5ODY3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "St Kilda Social Club Night",
    stat: "1 court · sundown session",
    url: "https://images.unsplash.com/photo-1537228783107-df09e892bdbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxvdXRkb29yJTIwc3BvcnRzJTIwZXZlbnQlMjBjcm93ZHxlbnwwfHx8fDE3OTE0Mjk4Njd8MA&ixlib=rb-4.1.0&q=85",
  },
];

const SpotlightCard = ({ item, tall, wide }) => {
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const aspect = tall ? (wide ? "aspect-[4/5] lg:aspect-[16/9]" : "aspect-[4/5]") : "aspect-[4/3]";
  return (
    <div
      data-testid={tall ? "event-gallery-card" : "activations-photo-item"}
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        setPos({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
      }}
      className={`group relative overflow-hidden rounded-3xl ring-1 ring-white/10 ${aspect}`}
    >
      <img
        src={item.url}
        alt={item.title || item.label}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{ background: `radial-gradient(280px at ${pos.x}% ${pos.y}%, rgba(212,255,0,0.22), transparent 70%)` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        {item.tag && <p className="mb-1 font-mono text-[11px] uppercase tracking-[0.2em] text-volt">{item.tag}</p>}
        <p className="font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl">
          {item.title || item.label}
        </p>
        {item.stat && <p className="mt-1 text-xs text-white/60">{item.stat}</p>}
      </div>
    </div>
  );
};

export default function Showcase() {
  return (
    <>
      <section id="ideas" className="relative py-24 lg:py-32" data-testid="event-gallery-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHead eyebrow="Your next activation" title="Ideas for your next event" testid="event-gallery-heading" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {EVENT_IDEAS.map((item, i) => (
              <Reveal key={item.title} delay={(i % 3) * 0.08} className={i === 0 ? "sm:col-span-2 lg:col-span-2" : ""}>
                <SpotlightCard item={item} tall wide={i === 0} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-carbon py-24 lg:py-32" data-testid="activations-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHead eyebrow="Previous activations" title="Seen at events across Melbourne" testid="activations-heading" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {ACTIVATIONS.map((item, i) => (
              <Reveal key={item.label} delay={(i % 4) * 0.08}>
                <SpotlightCard item={item} tall={false} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
